module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.1d7bcee1.woff2";